/**
 * Typed Redux hooks for use throughout the application
 *
 * Use these hooks instead of plain `useDispatch` and `useSelector`
 * for better TypeScript inference and autocomplete
 */

import { useDispatch, useSelector } from 'react-redux'
import type { RootState, AppDispatch } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
